import { useCallback } from 'react'
import { type EffectType, useSoundActions } from 'src/store/sound'

export const useSoundEffect = () => {
  const soundStoreActions = useSoundActions()
  const playEffect = useCallback(
    (soundId: string) => {
      soundStoreActions.playEffect(soundId as EffectType)
    },
    [soundStoreActions]
  )

  // Named convenience for the crash bust "thump" — the standalone Howl fired
  // once at the crash when the player had losing bets riding (CrashChipPanel).
  // Routes through the same effects queue as playEffect, so it honors the
  // effects volume + mute exactly like every other cue.
  const playCrashBust = useCallback(() => {
    soundStoreActions.playEffect('crashBust')
  }, [soundStoreActions])

  return {
    playEffect,
    playCrashBust
  }
}
